import type { Powertrain } from 'atoms/powertrainAtom';

// 計算セットの一意性を表す identity key を組み立てる純粋関数。
// 一意キーは powertrain ＋ 階層 id（R は unit_id を含む。L は unit を持たないため '' 扱い）。
// 新規作成フォームの「参照元と完全一致＝作成時 409」を事前に検知する重複ガードで、
// 参照元キーと現在の入力キーを同じ並びで突き合わせるために用いる。
export interface CalcIdentityParts {
    project_id: string;
    destination_id: string;
    lot_id: string;
    phase_id: string;
    unit_id?: string;
    calculation_id: string;
}

export const buildCalcIdentityKey = (
    powertrain: Powertrain,
    parts: CalcIdentityParts,
): string =>
    [
        powertrain,
        parts.project_id,
        parts.destination_id,
        parts.lot_id,
        parts.phase_id,
        parts.unit_id ?? '',
        parts.calculation_id,
    ].join('|');
